
// -- React Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// -- Libraries
import appActions from '../../redux/app/actions';
const { appSelected, searchTermUpdated } = appActions;

// -- Components
import Header from "../../components/Headers/index";
import HeaderLogo from "../../components/Headers/Logo";
import HeaderMenu from "../../components/Headers/Menu";
import Footer from "../../components/Footer/index";

import OrderSummary from "./OrderSummary/index";

// -- Styles
import OrderSuccessWrapper from './style';
import basicStyle from '../../config/basicStyle';

// -- Resources
import ImgArrowRightWhite from "../../image/arrow_white.png";

class OrderSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripe: 
      null
    };
  }
  
  componentWillUpdate(){
    console.log( ' componentWillUpdate');
    //check difference
    
  }
  
  createCampaignFake(campaign){
  }

  render() {
    console.log( this.props);
    
    const { appDetail } = this.state;
    const { searchTerm, campaign, currentApp, secondApp} = this.props;    
    const { rowStyle, colStyle } = basicStyle;


    return (
      <OrderSuccessWrapper className="page-wrapper">
        <Header>
          <div className="header-row">
            <HeaderLogo isClickable={true} history={this.props.history} />
            <HeaderMenu history={this.props.history} auth={this.props.auth}/>
          </div>

          <div className="header-row">
            <div className="subtitle">
              Thank you, your payment was successful.
            </div>
          </div>
        </Header>
        
        <div>
          <div className="content-wrapper">
            <OrderSummary
              appName="Starbucks app"
              imgUrl="https://is3-ssl.mzstatic.com/image/thumb/Purple125/v4/ed/f9/b8/edf9b88a-ee19-6028-e7f3-6aceebef61b5/source/100x100bb.jpg"
              price={82.87}
            />
            
            <div className="message">
              A receipt will be sent to your email shortly.
            </div>

            <div>
              <button
                className="order-callback"
                onClick={ () => { this.props.history.push("/dashboard"); } }
              >
                View campaign performance
                <img src={ImgArrowRightWhite}/>
              </button>
            </div>
          </div>
        </div>

        <Footer/>
      </OrderSuccessWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch) ,

  }
}
function mapStateToProps(state) {
  const campaign  = state.get('deep').campaign;
  return { 
    search: state.get('search'),
    campaign: campaign,
    currentApp: state.getIn( ['App', 'currentApp']),
    secondApp: state.getIn( ['App', 'secondApp']),
    searchTerm: state.getIn( ['App', 'searchTerm']),

  }
}

export default  (connect(
  mapStateToProps,
  mapDispatchToProps
)(  OrderSuccess) );



// WEBPACK FOOTER //
// ./src/containers/OrderSuccess/index.js